import { useEffect, useRef, useCallback } from 'react';
import styles from './CarruselLogos.module.css';

// direccion: 1 = izquierda (default), -1 = derecha
const CarruselLogos = ({ items, carpeta, velocidad = 0.6, direccion = 1 }) => {
  const pistaRef = useRef(null);
  const posicionRef = useRef(0);
  const pausadoRef = useRef(false);
  const rafRef = useRef(null);
  const anchoMitadRef = useRef(0);

  useEffect(() => {
    const pista = pistaRef.current;
    if (!pista) return;

    // Wait a frame so images have started rendering and layout is settled
    const timer = setTimeout(() => {
      anchoMitadRef.current = pista.scrollWidth / 2;
      // Right-moving carousel starts halfway so it can scroll right seamlessly
      if (direccion === -1) posicionRef.current = anchoMitadRef.current;

      const animar = () => {
        if (!pausadoRef.current && pistaRef.current) {
          if (direccion === 1) {
            posicionRef.current += velocidad;
            if (posicionRef.current >= anchoMitadRef.current) {
              posicionRef.current -= anchoMitadRef.current;
            }
          } else {
            posicionRef.current -= velocidad;
            if (posicionRef.current <= 0) {
              posicionRef.current += anchoMitadRef.current;
            }
          }
          pistaRef.current.style.transform = `translateX(-${posicionRef.current}px)`;
        }
        rafRef.current = requestAnimationFrame(animar);
      };

      rafRef.current = requestAnimationFrame(animar);
    }, 120);

    return () => {
      clearTimeout(timer);
      cancelAnimationFrame(rafRef.current);
    };
  }, [items, velocidad, direccion]);

  const moverManual = useCallback((btn) => {
    const pista = pistaRef.current;
    if (!pista) return;
    const tarjeta = pista.querySelector('[data-tarjeta]');
    if (!tarjeta) return;
    const anchoTarjeta = tarjeta.offsetWidth + 20;

    posicionRef.current += btn * anchoTarjeta;
    if (posicionRef.current < 0) posicionRef.current += anchoMitadRef.current;
    if (posicionRef.current >= anchoMitadRef.current) posicionRef.current -= anchoMitadRef.current;

    // Slide suave al hacer clic
    pista.style.transition = 'transform 0.42s cubic-bezier(0.4, 0, 0.2, 1)';
    pista.style.transform = `translateX(-${posicionRef.current}px)`;
    // Quitar la transición después para que el RAF continúe sin lag
    setTimeout(() => {
      if (pistaRef.current) pistaRef.current.style.transition = '';
    }, 450);
  }, []);

  const itemsDobles = [...items, ...items];

  return (
    <div
      className={styles.carruselContenedor}
      onMouseEnter={() => { pausadoRef.current = true; }}
      onMouseLeave={() => { pausadoRef.current = false; }}
    >
      <button
        className={`${styles.btnFlecha} ${styles.btnIzquierda}`}
        onClick={() => moverManual(-1)}
        aria-label="Anterior"
      >
        ‹
      </button>

      <div className={styles.carruselMascara}>
        <div ref={pistaRef} className={styles.carruselPista}>
          {itemsDobles.map((item, i) => (
            <div key={i} data-tarjeta="" className={styles.tarjetaLogo}>
              <img
                src={`/imagenes/${carpeta}/${item.archivo}`}
                alt={item.nombre}
                className={styles.logoImg}
                loading="lazy"
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>

      <button
        className={`${styles.btnFlecha} ${styles.btnDerecha}`}
        onClick={() => moverManual(1)}
        aria-label="Siguiente"
      >
        ›
      </button>
    </div>
  );
};

export default CarruselLogos;
